module.exports = {
  name: "Chanchala",
  greeting: "Hello 👋",
  greetingDescription: "I'm Chanchala & I'm a Software Engineer!",
  githubUrl: "https://github.com/ChanchalaGorale",
  linkedinUrl: "https://www.linkedin.com/in/chanchala-g-2b040411a/",
  cvLink:
    "https://docs.google.com/document/d/1LcAEzJDhNGNGKnsXWDsfSHlvWWS2pYMJaHMtbBDlvBI/edit?usp=sharing",
  copyright: "© 2021 Chanchala, All rights reserved.",
  introone:
    "I am a software developer, skilled in MERN(MongoDB-Express-React-Node.js) stack. Currently I am learning Python...",
  introtwo: "You can take a look at my projects and resume.",
  introthree:
    "Apart from developing, I love to travel-specially adventure trips, painting, and cooking. You can see some highlights of my trips",
};
